import { render, staticRenderFns } from "./commissionSetting2.vue?vue&type=template&id=45645d0a&scoped=true"
import script from "./commissionSetting2.vue?vue&type=script&lang=js"
export * from "./commissionSetting2.vue?vue&type=script&lang=js"
import style0 from "./commissionSetting2.vue?vue&type=style&index=0&id=45645d0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45645d0a",
  null
  
)

export default component.exports